module.exports = __webpack_public_path__ + "img/bündnis-c-logo.53c1932c.png";